export default function normalizeDropdownItems(rawConferences) {
  const conferenceList = [];

  if (!Object.prototype.hasOwnProperty.call(rawConferences[0], 'name'))
    conferenceList.push({ name: 'Leagues', divider: true });
  let conference;

  rawConferences.forEach(conferenceGroup => {
    if (Object.prototype.hasOwnProperty.call(conferenceGroup, 'name')) {
      conferenceList.push({
        name: conferenceGroup.name,
        divider: true,
      });
    }

    conferenceGroup.conferences.forEach(entry => {
      if (entry.route) {
        conference = {
          name: entry.name,
          route: entry.route,
        };
      } else {
        conference = {
          name: entry,
        };
      }

      conferenceList.push(conference);
    });
  });

  return conferenceList;
}
